// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hRULzR5AucVSor {
  max-width: 400px;
  height: 32px;
  margin-bottom: var(--ds-space-0, 0px);
  padding-right: var(--ds-space-150, 12px);
  padding-left: var(--ds-space-100, 8px);
  overflow: hidden;
  border: none;
  border-radius: 3px;
  font-weight: var(--ds-font-weight-medium, 500);
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-highlighted);
  color: var(--dynamic-button-highlighted-text);
}
.hRULzR5AucVSor svg circle {
  stroke: var(--dynamic-icon);
}
.hRULzR5AucVSor:hover {
  background: var(--dynamic-button-highlighted-hovered);
  color: var(--dynamic-button-highlighted-text);
}
.hRULzR5AucVSor.KCZ7cQ0pt6WUaN {
  background-color: var(--dynamic-button);
  color: var(--dynamic-text);
}
.hRULzR5AucVSor.KCZ7cQ0pt6WUaN svg circle {
  stroke: var(--dynamic-icon);
}
.hRULzR5AucVSor.KCZ7cQ0pt6WUaN:hover {
  background-color: var(--dynamic-button-hovered);
  color: var(--dynamic-text);
}
.hRULzR5AucVSor.KCZ7cQ0pt6WUaN:hover svg circle {
  stroke: var(--dynamic-icon);
}
.h8p3iM4NjGlJCf {
  display: flex;
  align-items: center;
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px);
}
.Z74oSZ7y0fL4sA {
  margin-left: var(--ds-space-050, 4px);
}
@media print {
  .Z74oSZ7y0fL4sA {
    color: var(--ds-text, #172b4d);
  }
}
.PsQY0grCVhhv8f {
  position: relative;
  top: 1px;
}
@media print {
  .PsQY0grCVhhv8f svg {
    color: var(--ds-text, #172b4d);
  }
}
.t2ZtXK3ZBDQkQS {
  padding: var(--ds-space-050, 4px);
}
.l5P7rfyPLrfjxi {
  overflow: visible;
}
.kCSLpSGfVwLSPz {
  margin-left: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardShareButton": `hRULzR5AucVSor`,
	"embedded": `KCZ7cQ0pt6WUaN`,
	"flexButton": `h8p3iM4NjGlJCf`,
	"boardShareButtonText": `Z74oSZ7y0fL4sA`,
	"boardShareButtonIcon": `PsQY0grCVhhv8f`,
	"personAddIconContainer": `t2ZtXK3ZBDQkQS`,
	"inviteDialog": `l5P7rfyPLrfjxi`,
	"accessRequestsBadgeContainer": `kCSLpSGfVwLSPz`
};
export default ___CSS_LOADER_EXPORT___;
